import Parse from 'parse';

class ConfigService {
  static instance = null;
  #config = null;

  static getInstance() {
    if (!ConfigService.instance) {
      ConfigService.instance = new ConfigService();
    }
    return ConfigService.instance;
  }

  async initialize() {
    try {
      this.#config = await Parse.Config.get();
    } catch (error) {
      console.error('Error fetching Parse config:', error);
      throw error;
    }
  }

  getPlatformFees() {
    return this.#config?.get('platform_fees') ?? 30; // default 30%
  }

  getUSDValue() {
    return this.#config?.get('usd_credits') ?? 1; // default value
  }

  getCoinsValue() {
    return this.#config?.get('credits_usd') ?? 185; // default value
  }

  getWithdrawPercent() {
    return this.#config?.get('withdraw_percent') ?? 100; // default 100%
  }

  getCoinValueUsd() {
    return this.getUSDValue() / this.getCoinsValue();
  }
}

export default ConfigService;
